import { GeneralDataFacade } from '@/_store/general/general.facade';
import { OffersFacade } from '@/_store/offers/offers.facade';
import { MobileDialogService } from '@/common/mobile-dialog/mobile-dialog.service';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TopSearchFilterItemsBase } from '../top-search-filter-items.base';

@Component({
	selector: 'app-top-search-filter-items-horizontal',
	templateUrl: './top-search-filter-items-horizontal.component.html',
	styleUrls: ['../top-search-filter-items.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopSearchFilterItemsHorizontalComponent extends TopSearchFilterItemsBase {
	constructor(
		offersFacade: OffersFacade,
		generalFacade: GeneralDataFacade,
		mobileDialogService: MobileDialogService,
	) {
		super(offersFacade, generalFacade, mobileDialogService);
	}
}
